module.exports = __webpack_public_path__ + "img/gas.aa654a3b.svg";